import React, { useCallback, useRef, useState } from "react";
import type { PointData } from "pixi.js";
import { Container, Graphics, Text } from "pixi.js";
import { extend, useTick } from "@pixi/react";
import { IPixPolygon } from "../types";

import PixBimContextMenuItem from "./PixBimContextMenuItem";

extend({ Text });
extend({ Graphics });
extend({ Container });

interface PixBimContextMenuProps {
  onClick?: (action: string, polygon: IPixPolygon) => void;
  polygon: IPixPolygon;
  textColor?: string;
  fontSize?: number;
  position: PointData;
}

const PixBimContextMenu: React.FC<PixBimContextMenuProps> = ({
  onClick,
  polygon,
  position,
  fontSize = 14,
  textColor = "#000000",
}) => {
  const menuRef = useRef<Container>(null);
  const { rightClickMenu } = polygon;
  const lineHeight = fontSize * 1.3;
  const amoutOfRows = (rightClickMenu || []).length;
  const [dimension] = useState<{ width: number; height: number }>({
    width: 150,
    height: amoutOfRows * lineHeight + amoutOfRows * 2,
  });
  useTick(() => {
    if (menuRef.current) {
      menuRef.current.position = position;
    }
  });
  const draw = useCallback(
    (g: Graphics) => {
      const { width, height } = dimension;
      g.clear();
      g.drawRoundedRect(-5, -5, width + 10, height + 10, 4);
      g.eventMode = "static";
      g.stroke({ color: "#999999" });
      g.fill({ color: "#EEEEEE" });
    },
    [dimension]
  );
  const onMenuItemClick = (text: string) => {
    onClick && onClick(text, polygon);
  };
  return (
    <container ref={menuRef} position={position}>
      <graphics draw={draw} />
      {rightClickMenu &&
        rightClickMenu.map((text, index) => {
          return (
            <PixBimContextMenuItem
              index={index}
              key={`context-menu-item-${index}`}
              width={150}
              fontSize={fontSize}
              textColor={textColor}
              text={text}
              onClick={() => onMenuItemClick(text)}
            />
          );
        })}
    </container>
  );
};

export default PixBimContextMenu;
